var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4739 6.05557C12.4621 6.36346 13.3881 6.8638 14.1952 7.53612M16.7229 4.9722C14.6123 3.11173 11.8954 2.08523 9.08184 2.08523C8.64489 2.08523 8.21027 2.10999 7.77989 2.15878M6.57563 10.1072C7.30883 9.58634 8.18595 9.30648 9.08535 9.30648C9.98475 9.30648 10.8619 9.58634 11.5951 10.1072M9.0819 12.9167H9.08912M1.2771 5.11722C2.24026 4.23461 3.35351 3.51315 4.57415 2.99554M3.83274 7.67548C4.84197 6.78643 6.07869 6.14956 7.44436 5.86339M11.7529 10.2265C11.0169 9.64953 10.0895 9.30556 9.08181 9.30556C8.05886 9.30556 7.1187 9.66001 6.37744 10.2528M2.5819 1L15.5819 14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOff);
export default __webpack_public_path__ + "static/media/WifiOff.5be747b58bfa11b5a4e18743811a7b57.svg";
export { ForwardRef as ReactComponent };